
import styled, { css } from 'styled-components';
import { StackPanel, Label } from '@agilepoint/wat-react-ux';

export const StyledErrorMessage = styled('div').attrs(() => ({
    className: 'ap-formField-errorMessage',
    role: 'alert'
}))`
    color: ${({ theme: { semantics: { palette: { red } } } }) => red};
    font-size: 13px;
`;

export const fullWidth = css`
    width: 100%;
`;

export const FieldBlock = styled(StackPanel)`
    ${fullWidth};
`;

export const FieldLabel = styled(Label).attrs({
    className: 'ap-formField-label'
})``;
